module.exports = __webpack_public_path__ + "static/media/stm-wallet.2a4f4b8a.svg";